import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../Loader.jsx";
import axios from 'axios';
import { IconArrowUpRight } from '@tabler/icons-react';

const Userdashboard = () => {
  const [desktop, setDesktop] = useState({ totalQuotation:0, totalOrder:0 });
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const GetUserDesktop = () => {
    setLoader(true)
    axios({
      method:"GET",
      url:`${process.env.REACT_APP_BASE_URL}/user/desktop/${user._id}`,
      headers: {
        "Content-Type":"application/json",
        "Authorization":`Bearer ${token}`
      }
    }).then(res => {
      setLoader(false)
      setDesktop({
        totalQuotation: res.data?.totalQuotation,
        totalOrder: res.data?.totalOrder
      });
    }).catch(() => {
      setLoader(false)
    });
  }
  useEffect(() => {
    GetUserDesktop();
  }, []);
  return (
    <>
      <section className='user-dashboard'>
        <Container>
          <Row className='justify-content-center'>
            <Col xl={4} md={6} className='mb-md-0 mb-4' onClick={() => navigate('/userrequestquote')}>
              <Card className="info_card">
                <Card.Body>
                  <Card.Title variant="h2" className='d-flex align-items-center justify-content-between'>
                    <span>My Quotation</span>
                    <Link to="/userrequestquote" className='button blue p-2 rounded-pill'>
                      <IconArrowUpRight size={20} stroke={2} />
                    </Link>
                  </Card.Title>
                  <Card.Text>
                    <strong className="display-1 fw-bold">{desktop.totalQuotation?.toLocaleString()}</strong>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col xl={4} md={6} onClick={() => navigate('/userorders')}>
            <Card className="info_card">
                <Card.Body>
                  <Card.Title variant="h2" className='d-flex align-items-center justify-content-between'>
                    <span>My Order</span>
                    <Link to="/userorders" className='button blue p-2 rounded-pill'>
                      <IconArrowUpRight size={20} stroke={2} />
                    </Link>
                  </Card.Title>
                  <Card.Text>
                    <strong className="display-1 fw-bold">{desktop.totalOrder?.toLocaleString()}</strong>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Loader show={loader}/>
    </>
  )
}

export default Userdashboard